import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, Divider, Stack, Typography } from '@mui/material';
import { hideLoader, showLoader } from '@utils/Loader';
import { showAlertError } from '@utils/Alerts/Error';
import Grid from '@mui/material/Grid';
import SalesChannelsService from '@api/SalesChannels/SalesChannelCtrl';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import useOpenModal from '@hooks/useOpenModal';
import { ModalSaveSalesChannel } from '@components/Admin/SalesChannels/Modals/ModalSaveSalesChannel';
import { showAlertMessage } from '@utils/Alerts/Message';
import { refreshSalesChannels } from '@utils/Catalogs';
const SalesChannelsScreen: React.FunctionComponent = () => {
    const salesChannelsService = useMemo(() => new SalesChannelsService(), []);
    const [salesChannels, setSalesChannels] = useState<SalesChannel[]>([]);
    const [currentSalesChannel, setCurrentSalesChannel] = useState<SalesChannel | undefined>(undefined);
    const modalAddSalesChannel = useOpenModal();

    const onSaveSalesChanel = async (salesChannel: SalesChannel) => {
        showLoader();
        try {
            await salesChannelsService.saveSalesChannel(salesChannel);
            showAlertMessage('Canal de venta guardado exitosamente');
            await getData();
            await refreshSalesChannels();
        } catch (error) {
            showAlertError(error);
        }
        hideLoader();
    };

    const onEditSalesChannel = async (salesChannel: SalesChannel) => {
        setCurrentSalesChannel(salesChannel);
        modalAddSalesChannel.toggle();
    };

    const onDeleteSalesChannel = async (salesChannel: SalesChannel) => {
        showLoader();
        try {
            if (salesChannel.id) {
                await salesChannelsService.deleteSalesChannel(salesChannel.id);
                showAlertMessage('Canal de venta eliminado exitosamente');
                await getData();
                await refreshSalesChannels();
            }
        } catch (error) {
            showAlertError(error);
        }
        hideLoader();
    };
    const getData = async () => {
        showLoader();
        try {
            const salesChannelsData = await salesChannelsService.getSalesChannels();
            setSalesChannels(salesChannelsData);
        } catch (error: any) {
            showAlertError(error);
        }
        hideLoader();
    };

    useEffect(() => {
        void getData();
    }, []);

    return (
        <Grid container height="100%" p={4}>
            <Grid item xs={6}>
                <Stack component={Card} boxShadow={4} borderRadius={4} p={4} height="100%">
                    <Stack spacing={2}>
                        <Typography variant="h5" fontWeight={600}>
                            Canales de venta
                        </Typography>
                        <Typography variant="body2">Agrega y edita los canales de venta disponibles.</Typography>
                        <Divider />
                        <Typography variant="body1" pb={1}>
                            Venta en mostrador (por defecto)
                        </Typography>
                        {salesChannels.map((salesChannel, index) => (
                            <Stack width="100%" key={index} direction="row" justifyContent="space-between">
                                <Typography variant="body1">{salesChannel.name}</Typography>
                                <Stack direction="row" spacing={2}>
                                    <IconButton onClick={() => onEditSalesChannel(salesChannel)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton onClick={() => onDeleteSalesChannel(salesChannel)}>
                                        <DeleteOutlineIcon />
                                    </IconButton>
                                </Stack>
                            </Stack>
                        ))}
                        <Button onClick={() => modalAddSalesChannel.toggle()}>+ Agregar canal de venta</Button>
                    </Stack>
                </Stack>
            </Grid>
            <ModalSaveSalesChannel
                modalSaveSalesChannel={modalAddSalesChannel}
                salesChannel={currentSalesChannel}
                onSaveSalesChanel={onSaveSalesChanel}
            />
        </Grid>
    );
};
export default SalesChannelsScreen;
